import { ThemeContext } from "../../Context/theme";
import React from "react";
import { useContext } from "react";
import photo from "../../Assets/photo.jpg";
import "./Introduction.css"

const Introduction = () => {
  const [{ themename }] = useContext(ThemeContext);
  return (
    <div>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About<span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src={photo} alt="myPhoto" />
            </div>
            <div className="introduction_datacontainer">
                
                <h4>
                Hi Everyone, I am{" "}
                <span className="different">Mamata Ingole</span> from{" "}
                <span className="different">🏡 Nanded, Maharashtra</span>.
                </h4>
                <h4> I have completed my  B.Tech in Electrical Engineering from Government College of Engineering Jalgaon.</h4>
                <h4>
                😍 I like watching movies, listening to music, cooking, and traveling.
                </h4>
                <h4>
                ❤️ I love designing websites and I am looking for more opportunities to work in coding.
                </h4>
                <h4>
                🤗 Apart from being a good technocrat, I wish to contribute to the betterment of society with the knowledge I have gained so far and will be,in the coming years.
                </h4>

            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Introduction;
